import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Layout.css';
import HomeHeader from '../Header/HomeHeader';
import LandingHeader from '../LandingPage/LandingHeader';
import CookiesDisclaimer from '../CookiesDisclaimer';
import HeaderModal from '../HeaderModal';
import LoginModal from '../LoginModal';
import SignupModal from '../SignupModal';
import ForgotPassword from '../ForgotPassword';
import Toaster from '../Toaster';
import WishListModal from '../WishListModal';

class LandingLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    isAuthenticated: PropTypes.bool,
    layoutType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    wishListModalOpen: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
  };

  render() {
    const { children, isAuthenticated, layoutType, wishListModalOpen } = this.props;

    return (
      <>
        {isAuthenticated ? (
          <HomeHeader borderLess layoutType={layoutType} />
        ) : (
          <LandingHeader />
        )}
        {children}
        <LoginModal />
        <SignupModal />
        <ForgotPassword />
        {wishListModalOpen && <WishListModal />}
        {!isAuthenticated && <HeaderModal />}
        {!isAuthenticated && <Toaster />}
        <CookiesDisclaimer />
      </>
    );
  }
}

const mapState = (state) => ({
  isAuthenticated: state.runtime.isAuthenticated,
  layoutType: state.siteSettings && state.siteSettings.data && state.siteSettings.data.homePageType,
  wishListModalOpen: state.modalStatus && state.modalStatus.wishListModalOpen,
});

export default withStyles(s)(connect(mapState)(LandingLayout));
